/**
 * Normalizes an effect's Standard flag to the canonical string shape.
 * The field exists in the wild as string 'true'/'false' AND boolean
 * true/false (older portfolio sync writers) — every write must emit the
 * string shape so `Standard === 'true'` consumers keep working.
 * AI-CONTEXT: See docs/pitfalls.md#database-string-enum-boolean-coercion
 *
 * @param {string | boolean | undefined | null} value - Standard flag in any legacy shape
 * @returns {'true' | 'false'} canonical string shape
 */
const normalizeStandard = (value) => (value === true || value === 'true' ? 'true' : 'false')

export default normalizeStandard
